import { camelCase, upperFirst } from "lodash";

/**
 * Convert string to PascalCase
 * @param {String} string 
 * @returns {String}
 */
export function pascalCase(string) {
  return upperFirst(camelCase(string));
}